import i18next from 'i18next';

// global
export const TERMINAL_ERROR = 'terminal';
export const GROWLER_ERROR = 'growler';
export const WEBPCSC_ERROR = 'webpcsc';
export const LOGLEVEL_KEY = 'UUPloglevel';
export const AC_AWAIT_MARKER = 'AC_AWAIT';
export const loggerLevels = {
    TRACE: 'TRACE',
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR',
    SILENT: 'SILENT',
};

export const FORM_KEYS = {
    pin: 'pin',
    pass: 'pass',
    serial: 'serial',
    userId: 'userId',
    currentPin: 'currentPin',
    confirmPin: 'confirmPin',
    autoSuggest: 'autoSuggest',
    searchBar: 'searchBar',
};

export const SCRUB_KEYS = {
    [FORM_KEYS.pin]: true,
    [FORM_KEYS.pass]: true,
    [FORM_KEYS.currentPin]: true,
    [FORM_KEYS.confirmPin]: true,
};

export const USER_MODE = 'user';
export const KIOSK_MODE = 'kiosk';
export const REMAINING_TIME_BEFORE_IDLE_TIMEOUT_ALERT = 60000;
export const PROGRESS_BAR_DONE_DELAY = 250;
export const MAX_RATING = 5;

// Endpoints
export const deviceEndpoint = '/device';
export const userEndpoint = '/user';
export const securityEndpoint = '/user/security';
export const settingsEndpoint = '/setting';
export const logOutEndpoint = '/saml/logout';
export const metadataEndpoint = '/setting/metadata';
export const credentialEndpoint = '/credential';
export const adminDeviceEndpoint = '/device';
export const adminUserEndpoint = '/user';
export const disableDeviceEndpoint = '/device/disable';
export const enableDeviceEndpoint = '/device/enable';
export const revokeDeviceEndpoint = '/device/revoke';
export const revokeCertificateEndpoint = '/credential';
export const unassignDeviceEndpoint = '/device/unassign';
export const cleanupOutcomeEndpoint = '/device/cleanup/outcome';
export const revodeTmpEndpoint = '/security/tmpPwd';

// elements
export const scaffoldingDropdownToggleId = 'scaffolding-dropdown-toggle';
export const scaffoldingLogoutLinkId = 'scaffolding-logout-link';
export const flowButtonsForwardId = 'elementLibrary-flowButtons-forward';
export const flowButtonsBackwardId = 'elementLibrary-flowButtons-backward';
export const userInfoRowContainerId = 'cardLibrary-userInfo-rowContainer';
export const userInfoUpdateSecurityQuestionId =
    'cardLibrary-userInfo-updateSecurityQuestion';
export const userInfoSecurityQuestionAlertWarning =
    'cardLibary-userInfo-securityQuestionAlertWarning';
export const walletIconId = 'cardLibrary-enrollApn-walletIcon';
export const mobileOtpQRId = 'cardLibrary-enrollMobileOtp-QR';
export const autoSuggestId = 'my-circle-dropdown';
export const searchBarId = 'search-bar';
export const searchBarInputId = 'search-bar-input';
export const searchBarBtnId = 'search-bar-btn';

// cards
export const identitiesCardId = 'cardLibrary-identities-card';
export const issuanceTypeCardId = 'cardLibrary-issuanceType-card';
export const userEntryCardId = 'cardLibrary-userEntry-card';
export const terminusCardId = 'cardLibrary-terminus-card';
export const confirmRevokeCardId = 'cardLibrary-confirmRevoke-card';
export const selectReasonCardId = 'cardLibrary-selectReason-card';
export const enrollPivCardId = 'cardLibrary-enrollPiv-card';
export const enrollOtpCardId = 'cardLibrary-enrollOtp-card';
export const enrollMobileOtpCardId = 'cardLibrary-enrollMobileOtp-card';
export const enrollApnCardId = 'cardLibrary-enrollApn-card';
export const enrollQuestionCardId = 'cardLibrary-enrollQuestion-card';
export const enrollAxiadId = 'cardLibrary-enrollAxiadId-card';
export const enrollAxiadidGuidanceId = 'cardLibrary-enrollAxiadid-guidance';
export const enrollAxiadidSupportLinkId = 'cardLibrary-enrollAxiadid-supportLink';
export const validateQuestionCardId = 'cardLibrary-validateQuestion-card';
export const userInfoCardId = 'cardLibrary-userInfo-card';
export const localSettingsCardId = 'cardLibrary-localSettings-card';
export const associateDeviceCardId = 'cardLibrary-associateDevice-card';
export const associateUserCardId = 'cardLibrary-associateUser-card';
export const userEntryDelegateCardId = 'cardLibrary-userEntryDelegate-card';
export const associatePivResetCardId = 'cardLibrary-associatePivReset-card';
export const associatePivUpdateCardId = 'cardLibrary-associatePivUpdate-card';
export const resyncTypeCardId = 'cardLibrary-resyncOtp-card';
export const validateDeviceCardId = 'cardLibrary-validateDevice-card';
export const helpDeskCardId = 'cardLibrary-helpDesk-card';
export const reportsCardId = 'cardLibrary-reports-card';
export const emergencyInfoCardId = 'cardLibrary-emergency-card';
export const devicesInfoCardId = 'cardLibrary-devicesInfo-card';

// form
export const createPinFormId = 'formLibrary-createPin-formElement';
export const createPinFormWeakPinCheckId =
    'formLibrary-createPin-formElement-weakPinCheck';
export const createPinFormMinMaxLengthId =
    'formLibrary-createPin-formElement-minMaxLength';
export const createPinFormConstraintId =
    'formLibrary-createPin-formElement-constraint';
export const currentPinFormId = 'formLibrary-currentPin-formElement';
export const createQuestionFormId = 'formLibrary-createQuestion-formElement';
export const currentQuestionFormId = 'formLibrary-currentQuestion-formElement';
export const currentPinFormForgotId =
    'formLibrary-currentPin-forgot-formElement';
export const userIdFormId = 'formLibrary-userId-formElement';
export const resyncOtpFormId = 'formLibrary-resyncOtp-formElement';
export const passFormId = 'formLibrary-pass-formElement';
export const autoSuggestFormId = 'formLibrary-autoSuggest-formElement';
export const searchBarFormId = 'formLibrary-searchBar-formElement';

// utility
export const ucmsUnknownCard = 'Unsupported card';
export const webpcscNoService = 'E_NO_SERVICE';
export const MIN_VERSION_EXT = '1.0.10';
export const MIN_VERSION_APP = '1.0.0';
export const MIN_VERSION_APP_PIN_LENGTH = '1.9.0';
// The WebPCSC native app (not the extension) introduced the `dvsc` op;
// the extension auto-updates, WebPCSC does not.
export const MIN_VERSION_APP_VSC_DELETE = '1.10.0';

export const ucmsConstants = {
    stage: 'stage',
    done: 'done',
    actions: {
        identify: 'identify',
    },
};
export const serverConstants = {
    success: 'success',
    failure: 'failure',
};
const languageForm = 'messages_';
export const defaultLocale = 'en';

// navigation
/* global window */ // eslint-disable-line no-redeclare
export const homePath = '/';
export const loginURL = '/user/saml/login';
export const rootContext =
    window.location.pathname.split(homePath)[1] || USER_MODE; // default to user for e2e and unit test case
export const rootPath = `/${rootContext}`;
export const identitiesPath = '/identities';
export const helpDeskPath = '/helpdesk';
export const reportsPath = '/reports';
export const accountPath = '/account';
export const settingsPath = '/settings';
export const apiPath = `${rootPath}/api`;
export const graphQLEndpoint = `${rootPath}/graphql`;

export const paths = {
    account: `${accountPath}`,
    identities: `${identitiesPath}`,
    settings: '/settings',
    updateSecurity: `${accountPath}/security/reset`,
    delegations: '/delegation',
    helpDesk: '/helpdesk',
    credentialing: `${identitiesPath}/credentialing`,
    update: `${identitiesPath}/update`,
    disable: `${identitiesPath}/disable`,
    enable: `${identitiesPath}/enable`,
    changePin: `${identitiesPath}/changePin`,
    resetpin: `${identitiesPath}/resetpin`,
    resyncOtp: `${identitiesPath}/resyncOtp`,
    validateDeviceWithPin: `${identitiesPath}/validateDeviceWithPin`,
    validateDeviceWithoutPin: `${identitiesPath}/validateDeviceWithoutPin`,
    revoke: `${identitiesPath}/revoke`,
    revokeSponsor: `${identitiesPath}/revoke-piv`,
    revokeCertificate: `${identitiesPath}/revokeCertificate`,
    vscDelete: `${identitiesPath}/vsc-delete`,
    unassign: `${identitiesPath}/unassign`,
    recycle: `${identitiesPath}/recycle`,
    reports: '/reports',
    recovery: '/help',
    resetFailcounter: '/resetFailcounter',
    insights: '/insights'
};

export const pathRoot = {
    account: `${rootPath}${paths.account}`,
    identities: `${rootPath}${paths.identities}`,
    settings: `${rootPath}${paths.settings}`,
    delegations: `${rootPath}${paths.delegations}`,
    credentialing: `${rootPath}${paths.credentialing}`,
    update: `${rootPath}${paths.update}`,
    disable: `${rootPath}${paths.disable}`,
    enable: `${rootPath}${paths.enable}`,
    changePin: `${rootPath}${paths.changePin}`,
    resetpin: `${rootPath}${paths.resetpin}`,
    resyncOtp: `${rootPath}${paths.resyncOtp}`,
    helpDesk: `${rootPath}${paths.helpDesk}`,
    reports: `${rootPath}${paths.reports}`,
    insights: `${rootPath}${paths.insights}`,
};

export const helpDeskPaths = {
    update: `${helpDeskPath}/update`,
    disable: `${helpDeskPath}/disable`,
    enable: `${helpDeskPath}/enable`,
    changePin: `${helpDeskPath}/changePin`,
    resetpin: `${helpDeskPath}/resetpin`,
    resyncOtp: `${helpDeskPath}/resyncOtp`,
    validateDeviceWithPin: `${helpDeskPath}/validateDeviceWithPin`,
    validateDeviceWithoutPin: `${helpDeskPath}/validateDeviceWithoutPin`,
    revoke: `${helpDeskPath}/revoke`,
    revokeSponsor: `${helpDeskPath}/revoke-piv`,
    revokeCertificate: `${helpDeskPath}/revokeCertificate`,
    vscDelete: `${helpDeskPath}/vsc-delete`,
    unassign: `${helpDeskPath}/unassign`,
    rename: `${helpDeskPath}/rename`,
    addDevice: `${helpDeskPath}/users/:username/credentialing`,
    usersDetails: `${helpDeskPath}/users/:username`,
    recycle: `${helpDeskPath}/recycle`,
    resetFailcounter: `${helpDeskPath}/resetFailcounter`
};

export const reportViewBase = `${reportsPath}/view`;

export const reportsPaths = {
    reportView: `${reportViewBase}/:reportName`,
    reportNew: `${reportsPath}/new`,
};

export const tabPaths = {
    helpDesk: {
        devices: 'devices',
        users: 'users',
        scanner: 'scanner',
    },
};

export const subTabsPaths = {
    helpDesk: {
        devices: `${helpDeskPath}/devices`,
        users: `${helpDeskPath}/users`,
        scanner: `${helpDeskPath}/scanner`,
    },
    reports: {
        inventory: `${reportsPath}/inventory`,
        devices: `${reportsPath}/devices`,
        view: `${reportsPath}/view`,
        identityConfirmation: `${reportsPath}/identityConfirmation`,
    },
};

export const mainContent = {
    '/': ['btn-outline-primary'],
    [paths.identities]: ['btn-outline-primary'],
    [paths.credentialing]: ['form-control'],
    [paths.delegations]: ['form-control'],
};

// walkway
export const componentKeys = {
    ASSOCIATE_DEVICE: 'associateDevice',
    ASSOCIATE_PIV_ENROLL: 'associatePivEnroll',
    ASSOCIATE_PIV_UPDATE: 'associatePivUpdate',
    FIDO2_ENROLL: 'fido2Enroll',
    ASSOCIATE_USER: 'associateUser',
    CHANGE_PIN: 'changePin',
    DETECTION: 'messageCard',
    PIV_CHANGE_PIN: 'pivChangePin',
    PIV_RESET: 'pivReset',
    QUESTION_ENROLL: 'questionEnroll',
    RESET_PIN: 'resetPin',
    TERMINUS: 'terminus',
    USER_ENTRY: 'userEntry',
};

export const delegationConstants = {
    keys: {
        associateUser: 'associateUser',
        flowState: 'flowState',
        delegationOperation: 'delegationOperation',
    },
    states: {
        LOCKED: 'locked',
        NOT_LOCKED: 'notLocked',
    },
};

// branding
export const branding = {
    navLogo: {
        img: `${rootPath}/static/branding/images/navLogo.png`,
        alt: 'Axiad',
    },
};
export const activeColor = {
    bg: '#f0fff7',
    text: '#0d8224',
};
export const disabledColor = {
    bg: '#ebecef',
    text: '#42526d',
};
export const severeColor = {
    bg: '#ffe0e0',
    text: '#42526d',
};

export const infoColor = {
    bg: '#abc0ff',
    text: '#3057c9',
};
export const defaultPageTitle = 'Axiad Portal';

export const brandingJsonPath = `${rootPath}/static/branding/branding.json`;

// string builder functions
export const urlFetchWalkway = (action, type) =>
    `${rootPath}/api/device/${action}/${type}`;
export const composeLanguageFilename = (locale) => `${languageForm}${locale}`;
export const buildDeviceDropdownDisplaySuccess = (data, label) =>
    `${i18next.t(`mappingsLabels$deviceSubTypes$${data.subType}$label`) ||
    data.subType
    } - ${label} ${data.legibleid ? data.legibleid : data.serial}`;
export const buildDeviceDropdownDisplayFailure = (data) =>
    `${i18next.t(`mappingsLabels$deviceSubTypes$${data.subType}$label`) ||
    data.subType
    }: ${data.issuable}`;

// navbar (header)
export const navInsightsId = 'insights';
export const navIdentitiesId = 'identities';
export const navDelegationId = 'delegations';
export const navDropdownHelpId = 'help';
export const navDropdownSettingsId = 'settings';
export const navDropdownAccountId = 'account';
export const navDropdownLogoutId = 'logout';
export const navHelpDeskId = 'helpDesk';
export const navReportsId = 'reports';
export const navUserFeedbackId = 'userFeedback';

export const devicesTableId = 'devicesTable';
export const emptyDevicesTableId = 'emptyDeviceTable';
export const emptyDevicesLabelId = 'emptyDeviceLabel';
export const usersTableId = 'usersTable';
export const emptyUsersTableId = 'emptyUsersTable';
export const emptyUsersLabelId = 'emptyUsersLabel';

// key of column settings of each tables used in localStorage
export const helpdeskUsersQueryTableColumnsSettings =
    'helpdeskUsersQueryTableColumnsSettings';
export const identitiesTableColumnsSettings = 'identitiesTableColumnsSettings';
export const helpdeskDevicesQueryTableColumnsSettings =
    'helpdeskDevicesQueryTableColumnsSettings';
export const helpdeskScannerQueryTableColumnsSettings =
    'helpdeskScannerQueryTableColumnsSettings';
export const helpdeskUsersDevicesTableColumnsSettings =
    'helpdeskUsersDevicesTableColumnsSettings';
export const helpdeskEmergencyTableColumnsSettings =
    'helpdeskEmergencyTableColumnsSettings';
export const reportHomeColumnsKey = 'reportHomeColumnsKey';
export const reportDevicesTableColumnsSettings =
    'reportDevicesTableColumnsSettings';

export const vscPlaceholder = {
    0: 'Virtual Smart Card',
    atr: null,
    changed: true,
    device: {
        divData: null,
        serial: 'null',
        type: 'vsc',
        version: null,
    },
    label: 'vsc',
    display: 'Virtual Smart Card',
    readerName: 'vsc',
    serial: 'null',
    subType: 'vsc',
    type: 'smartcard',
    issuable: true,
};

export const whfbPlaceholder = {
    0: 'Windows Hello for Business',
    atr: null,
    changed: true,
    device: {
        divData: null,
        serial: 'null',
        type: 'hello',
        version: null,
    },
    label: 'whfb',
    display: 'Windows Hello for Business',
    readerName: 'whfb',
    serial: 'null',
    subType: 'hello',
    type: 'hello_windows',
    issuable: true,
};

export const whfbUserCancelErrCode = '0x80090036';

export const helpInfoIcon = 'helpInfoIcon';
export const redirectUrl = 'redirectUrl';

export const keyboardLayouts = ['us', 'fr'];

export const tableType = {
    emergency: 'emergency',
    device: 'device',
    user: 'user',
    rowDetailes: 'rowDetailes',
};

export const atrCases = {
    null: 'errorMsgs$atr_null',
    IN_USE: 'errorMsgs$atr_inUse',
    ERROR: 'errorMsgs$atr_error',
    default: 'errorMsgs$unissuable',
};

export const deviceType = {
    ctap_unqualified: "ctap_unqualified",
    ctap_windows: "ctap_windows"
}

export const confirmStepOutcome = {
    SUCCESS: {
        name: "Successful",
        color: "#D4F57D",
        text_color: "#006100"
    },
    FAILED: {
        name: "Failed",
        color: "#FCD4CA",
        text_color: "#C00000"
    },
    EXPIRED: {
        name: "Expired",
        color: "#FFF3CD",
        text_color: "#856404"
    }
}

export const idConfirmationStatus = {
    Unconfirmed: {
        name: "Unconfirmed",
        color: "#0B253817",
        text_color: "#44484C"
    },
    Pending: {
        name: "Pending",
        color: "#F9E997",
        text_color: "#44484C"
    },
    "In Process": {
        name: "In Process",
        color: "#D2E4FF",
        text_color: "#44484C"
    },
    "Processed": {
        name: "Processed",
        color: "#D4F57D",
        text_color: "#006100"
    },
    Confirmed: {
        name: "Confirmed",
        color: "#D4F57D",
        text_color: "#006100"
    },
    Failed: {
        name: "Failed",
        color: "#FCD4CA",
        text_color: "#C00000"
    },
    Expired: {
        name: "Expired",
        color: "#FFF3CD",
        text_color: "#856404"
    }
}
